// Dual-path auth state for the Station Board:
//  • machine boards: per-board account (custom claims) → new template/designer config
//  • legacy boards:  shared /users account (stationboard:true) → existing screens
const AuthReducer = (state, action) => {
  switch (action.type) {
    // Legacy login dispatch (kept so the existing Login flow keeps working).
    case "LOGIN": {
      return { ...state, currentUser: action.payload };
    }
    // Resolved auth + claims from onAuthStateChanged.
    case "SET_AUTH": {
      return { ...state, ...action.payload, authReady: true };
    }
    // This board's config doc (machine boards only).
    case "SET_CONFIG": {
      return { ...state, boardConfig: action.payload };
    }
    case "LOGOUT": {
      return {
        currentUser: null,
        claims: null,
        agency: null,
        boardId: null,
        mode: null,
        isStationboard: false,
        boardConfig: null,
        authReady: true,
      };
    }
    default:
      return state;
  }
};

export default AuthReducer;
